/* src/app/modules/invoice/deliverynotes/deliverynote.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
.conceptsList {
  height: 300px;
  overflow-x: auto;
}
table thead tr {
  background: #e3fd64;
}
tfoot {
  background-color: #343a40;
  color: white;
}
/*# sourceMappingURL=deliverynote.component.css.map */
